import { useEffect, useRef } from "react";

import { useApiQuery } from "~/api/use-api";
import { useLoadingScreen } from "~/components/app-shell/providers/loading-screen-provider";
import { useInfiniteConversation } from "~/hooks/chat/conversation";
import { ANSWER_KEY, ANSWERS_KEY, CONVERSATIONS_KEY } from "~/types/query-keys";
import { useTenantId } from "~/util/use-active-tenant-id";
import { useUser } from "~/util/use-user";

export const PreRunQueries: React.FC = () => {
  const { disease } = useTenantId();
  const disableUserQueries = useRef(true);
  const user = useUser();

  useEffect(() => {
    if (user?.userAttributes?.finishedSignUp)
      disableUserQueries.current = false;
  }, [user?.userAttributes?.finishedSignUp]);

  const { data: conversations } = useApiQuery(
    "multiagent",
    (api) => api.getConversations({ mamaDisease: disease }),
    CONVERSATIONS_KEY(disease),
    undefined,
    { enabled: disableUserQueries.current },
  );

  useLoadingScreen({
    isLoading: !(conversations && conversations.length === 0) && !conversations,
    message: { tx: "chat.loadingInitialChat" },
  });

  const conversationId = conversations?.[0]?.id;

  useInfiniteConversation({
    conversationId: conversationId as string,
    limit: 20,
    enabled: !!conversationId && disableUserQueries.current,
  });

  const { data: answerConversations } = useApiQuery(
    "multiagent",
    (api) => api.getAnswerConversations({ mamaDisease: disease }),
    ANSWERS_KEY(disease),
    undefined,
    {
      enabled: disableUserQueries.current,
    },
  );

  const answerConversationId = answerConversations?.[0]?.id;

  useApiQuery(
    "multiagent",
    (api) =>
      api.getAnswerConversationWithId({
        conversationId: answerConversationId as string,
      }),
    ANSWER_KEY(disease, conversationId),
    {},
    {
      refetchOnWindowFocus: false,
      enabled: !!answerConversationId && disableUserQueries.current,
    },
  );

  useLoadingScreen({
    isLoading:
      !(answerConversations && answerConversations.length === 0) &&
      !answerConversations,
    message: { tx: "chat.loadingInitialChat" },
  });

  return null;
};
